// Use for managing meta tags for pages

// Site defaults for index (currently hard-coded, to be revised)
export const SITE_TITLE = "Assay Marketplace: Tumor profiling made easy";
export const SITE_META_DESCR =
  "Find the perfect NGS assay to fit your research needs with the Assay Marketplace, designed for RNA, DNA, or ctDNA inputs";
export const SITE_LINK_CANONICAL = "https://assay-marketplace.archerdx.com";

// Catalog page
export const CATALOG_TITLE = "Browse our Catalog Panels | Assay Marketplace";
export const CATALOG_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/catalog";

// Login page
export const LOGIN_TITLE = "Sign-In | Assay Marketplace";
export const LOGIN_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/login";

// Register page
export const REGISTER_TITLE = "Register for an account | Assay Marketplace";
export const REGISTER_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/register";

// Upload Targets page
export const UPLOADTARGETS_TITLE = "Provide Targets | Assay Marketplace";
export const UPLOADTARGETS_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/upload-targets";

// Custom Panels page
export const CUSTOM_PANELS_TITLE = "Custom Panels | Assay Marketplace";
export const CUSTOM_PANELS_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/custom-panels";

// Contact page
export const CONTACT_TITLE = "Contact | Assay Marketplace";
export const CONTACT_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/contact";

// Technology Platform
export const TECHNOLOGY_PLATFORM_TITLE =
  "Technology Platform | Assay Marketplace";
export const TECHNOLOGY_PLATFORM_LINK_CANONICAL =
  "https://assay-marketplace.archerdx.com/technology-platform";

// Draft Custom Panels
export const DRAFT_CUSTOM_PANEL_TITLE =
  "Draft Custom Panels | Assay Marketplace";
